import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'productCount'
})
export class ProductCountPipe implements PipeTransform {

  transform(value: number): string {
    // Check if the value is greater than 3

    if (value > 3) {
      return '3+';
    }
    // Return the exact value as a string
    return value.toString();
  }

}
